export default "__VITE_ASSET__Cm1FYz_K__"